import { applyMiddleware, combineReducers, createStore, compose } from 'redux'
import { createLogger } from 'redux-logger'
// import { reducer as form } from 'redux-form'
import thunk from 'redux-thunk'

// Custom middleware
import SocketClient from '../common/SocketClient'
import createSocketMiddleware from './middleware/socket-middleware'

// Reducers
import user from '../actions/user/user-reducer'
import system from '../actions/system/system-reducer'
import ui from '../actions/ui/ui-reducer'
import game from '../actions/game/game-reducer'

const logger = createLogger({
  level: 'info',
  collapsed: true
})

const socketClient = new SocketClient()
const socketMiddleware = createSocketMiddleware(socketClient)

let reducer = combineReducers({
  // configuration: combineReducers({ report, ui }),
  user,
  system,
  ui,
  game
})

// Add support for Redux devtools extension. Yes, even in production.
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
// var store = createStore(reducer, composeEnhancers(applyMiddleware(logger, thunk, socketMiddleware)))
var store = createStore(reducer, composeEnhancers(applyMiddleware(logger, thunk, socketMiddleware)))
export default store
